@if (visible) {
	<div
		class="tw:h-14 tw:px-6 tw:py-2 tw:flex tw:gap-4 tw:items-center tw:justify-center tw:bg-info-highlight tw:text-info tw:font-semibold tw:text-sm"
	>
		{{ message }}
		<a
			routerLink="/user/change-password"
			[queryParams]="{ username }"
			class="tw:underline tw:cursor-pointer tw:text-info! tw:font-semibold! tw:text-sm!"
			>Reset Password</a
		>
		<span (click)="close()" class="tw:cursor-pointer tw:text-secondary tw:absolute tw:right-6">
			<mat-icon>close</mat-icon>
		</span>
	</div>
}
